import { IMenuJSON } from "../../../../redux/food/food.types";
import { ILead } from "../../../../redux/leads/leads.types";

export interface ILeadEventOption {
  label: string;
  value: string;
}

/**
 * Extracts category and subcategory max_selection values from menu JSON,
 * keyed by their respective UUIDs.
 *
 * Returns undefined when no limits exist in the menu data.
 */
export function extractLimits(
  menuJson: IMenuJSON[],
): Record<string, number> | undefined {
  const limits: Record<string, number> = {};

  menuJson.forEach((category) => {
    if (category.max_selection != null && category.max_selection > 0) {
      limits[category.category_uuid] = category.max_selection;
    }
    category.subcategories?.forEach((sub) => {
      if (
        sub.max_selection != null &&
        sub.max_selection > 0 &&
        sub.food_subcategory_name_uuid
      ) {
        limits[sub.food_subcategory_name_uuid] = sub.max_selection;
      }
    });
  });

  return Object.keys(limits).length > 0 ? limits : undefined;
}

/**
 * Derives event selector options from a lead's multiple_events_list.
 *
 * Falls back to a single option from the lead itself when the list
 * is empty or undefined.
 */
export function buildEventOptions(lead: ILead): ILeadEventOption[] {
  if (!lead.multiple_events_list || lead.multiple_events_list.length === 0) {
    return [
      {
        label: lead.event_name || "Default Event",
        value: lead.leads_uuid as string,
      },
    ];
  }

  return lead.multiple_events_list.map((event) => ({
    label: event.event_type || "Unknown Event",
    value: event.leads_uuid as string,
  }));
}
